import {Component, Input, OnChanges, OnInit, SimpleChanges, inject, OnDestroy} from '@angular/core';
import { NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIf, JsonPipe, NgClass, NgFor } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SharedFormService } from '../../services/shared-form.service';
import { ApiService } from '../../services/api.service';
import {Observable, OperatorFunction, Subject, debounceTime, distinctUntilChanged, first, map, switchMap, Subscription, firstValueFrom} from 'rxjs';
import { Asl, Comune, Dizionario, Icd10 } from '../../model/model';
import { AssignComuniService } from '../../services/assign-comuni.service';
import { SwitchModalitaService } from '../../services/switch-modalita.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-parte-a',
  standalone: true,
  imports: [NgbTooltipModule, NgIf, ReactiveFormsModule, FormsModule, NgbDatepickerModule, JsonPipe, NgClass, NgFor, NgbTypeaheadModule],
  templateUrl: './parte-a.component.html',
  styleUrl: './parte-a.component.scss'
})
export class ParteAComponent implements OnInit, OnDestroy {
  selectedOptionLuogo: string = '';
  selectedOptionLuogoTraumatismo: string = '';
  selectedOptionAccidentale: string = '';
  selectedOptionTipoIncidente: string = '';
  isHiddenQuesiti: boolean = true;
  isHiddenQuesitiSubject = new Subject<boolean>();
  isHiddenAccidentale: boolean = true;
  activateCondizione2: boolean = false;
  activateCondizione3: boolean = false;
  activateStato2: boolean = false;
  activateStato3: boolean = false;
  parteAForm = this.sharedFormService.form.get('parteA') as FormGroup;
  dizionari!: Observable<Dizionario[] | any>;
  dizionarioLuogoDecesso: any;
  dizionarioStatoGravidanza: any;
  dizionarioModalitaTraumatismo: any;
  dizionarioTrasportoRuolo: any;
  dizionarioLuogoEvento: any;
  dizionarioTipoMedico: any;
  //campi comune
  comuni: any = [];
  icd10: any = [];
  icd10Descrizione: any = [];
  codComuni: any = [];
  descrComune: any = [];
  descProvince: any = [];
  descrAsl: any;
  @Input() schedaMorte!: any;
  dataAttuale: Date = new Date();
  giaModifica: boolean = false;
  allAsl: any = [];
  aslDescr: any = [];
  id: string = '';
  route = inject(ActivatedRoute);

  descrAslDecesso: string = '';

  //subscription
  condizione1Subscription: any;
  condizione2Subscription: any;
  condizione3Subscription: any;
  condizione4Subscription: any;
  condizione5Subscription: any;
  condizione6Subscription: any;
  condizione7Subscription: any;
  condizione8Subscription: any;
  condizione9Subscription: any;
  condizione10Subscription: any;
  condizione11Subscription: any;
  condizione12Subscription: any;
  dizionariSubscription: any;
  comuniSubscription: any;
  icd10Subscription: any;

  disableSelect: boolean = false;


  invalidBorder(form: string) {
    if ((this.parteAForm.get(form)?.invalid && this.parteAForm.get(form)?.touched) || (this.parteAForm.get(form)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  invalidBorderIcd10(group: string, descrizione: string, codice: string) {
    if ((this.parteAForm.get(group)?.get(codice)?.invalid && this.parteAForm.get(group)?.get(descrizione)?.touched) || (this.parteAForm.get(group)?.get(codice)?.invalid && this.schedaMorte.attivaBordi) || (this.parteAForm.get(group)?.get(descrizione)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  invalidBorderIcd10Group(group: string, subgroup: string, descrizione: string, codice: string) {
    if ((this.parteAForm.get(group)?.get(subgroup)?.get(codice)?.invalid && this.parteAForm.get(group)?.get(subgroup)?.get(descrizione)?.touched) || (this.parteAForm.get(group)?.get(subgroup)?.get(codice)?.invalid && this.schedaMorte.attivaBordi) || (this.parteAForm.get(group)?.get(subgroup)?.get(descrizione)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  invalidBorderComune(form: string, group: string, codComune: string) {
    if ((this.parteAForm.get(group)?.get(form)?.invalid && this.parteAForm.get(group)?.get(form)?.touched) ||
      (this.parteAForm.get(group)?.get(form)?.invalid && this.schedaMorte.attivaBordi)
      || (this.parteAForm.get(group)?.get(codComune)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  invalidBorderGroup(form: string, group: string) {
    if ((this.parteAForm.get(group)?.get(form)?.invalid && this.parteAForm.get(group)?.get(form)?.touched) || (this.parteAForm.get(group)?.get(form)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  invalidBorderSubGroup(form: string, group: string, subgroup: string) {
    if ((this.parteAForm.get(group)?.get(subgroup)?.get(form)?.invalid && this.parteAForm.get(group)?.get(subgroup)?.get(form)?.touched) || (this.parteAForm.get(group)?.get(subgroup)?.get(form)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }




  showInputLuogo(value: Event) {
    this.selectedOptionLuogo = (value.target as HTMLSelectElement).value;
    this.setSelectedOption(this.selectedOptionLuogo, '9', 'luogoDecessoAltro');
  }

  setSelectedOptionAccidentale(value: Event) {
    this.selectedOptionAccidentale = (value.target as HTMLSelectElement).value;
    this.isHiddenAccidentale = this.selectedOptionAccidentale !== '1';
    this.parteAForm.get('traumatismoSulLavoro')?.reset();
    this.setSelectedOption(this.selectedOptionAccidentale, '1', 'traumatismoSulLavoro');
  }

  setSelectedOptionTipoIncidente(value: Event) {
    this.selectedOptionTipoIncidente = (value.target as HTMLSelectElement).value;
    this.setSelectedOptionGroup(this.selectedOptionTipoIncidente, 'incidenteTrasportoScontro', 'scontro', 'incidenteTrasporti');
  }

  showInputLuogoTraumatismo(value: Event) {
    this.selectedOptionLuogoTraumatismo = (value.target as HTMLSelectElement).value;
    this.setSelectedOption(this.selectedOptionLuogoTraumatismo, '9', 'altroLuogoEvento');
  }

  maxLengthInput(event: any, maxLength: number) {
    const input = event.target as HTMLInputElement;
    const isBackspace = event.key === 'Backspace';
    const isTab = event.key === 'Tab';

    if (input.value.length === maxLength && !isBackspace && !isTab) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  limitInput(input: EventTarget | null, maxLength: number) {
    const inputElement = input as HTMLInputElement;
    if (inputElement && inputElement.value.length > maxLength) {
      inputElement.value = inputElement.value.slice(0, maxLength);
    }
  }

  onHourInput(event: any, maxLength: number) {
    const input = event.target as HTMLInputElement;
    const firstDigit = parseInt(event.target.value[0], 10);
    const isBackspace = event.key === 'Backspace';
    const zero = event.key === '0';
    const uno = event.key === '1';
    const due = event.key === '2';
    const tre = event.key === '3';
    const isTab = event.key === 'Tab';

    if (firstDigit > 2 && !isBackspace && !isTab) {
      event.preventDefault();
    }
    else if(firstDigit == 2 && !zero && !uno && !due && !tre && !isBackspace && !isTab){
      event.preventDefault();
    }
    else if(input.value.length === maxLength && !isBackspace && !isTab){
      event.preventDefault();
    }
  }

  onMinuteInput(event: any, maxLength: number) {
    const input = event.target as HTMLInputElement;
    const firstDigit = parseInt(event.target.value[0], 10);
    const isBackspace = event.key === 'Backspace';
    const isTab = event.key === 'Tab';

    if (firstDigit > 5 && !isBackspace && !isTab) {
      event.preventDefault();
    }
    else if(input.value.length === maxLength && !isBackspace && !isTab){
      event.preventDefault();
    }
  }


  // restituisce i values dei forms group relativi alle cause delle condizioni di morte e agli stati morbosi
  //serve per poter essere richiamato dall'html per disabilitare i campi successivi se il precedente è vuoto

  get condizione1Value() {
    return this.parteAForm.get('causaMorteCondizioni')?.get('condizione1') as FormGroup;
  }

  get condizione2Value() {
    return this.parteAForm.get('causaMorteCondizioni')?.get('condizione2') as FormGroup;
  }

  get stato1Value() {
    return this.parteAForm.get('altriStatiMorbosi')?.get('stato1') as FormGroup;
  }

  get stato2Value() {
    return this.parteAForm.get('altriStatiMorbosi')?.get('stato2') as FormGroup;
  }

  hideQuesitiSubject() {
    this.isHiddenQuesiti = !this.isHiddenQuesiti;
    this.isHiddenQuesitiSubject.next(this.isHiddenQuesiti);
  }


  addQuesiti() {
    this.parteAForm.get('eventoTraumatismo')?.setValue('T');
    this.addRequired('eventoOrigineTraumatismo');
    this.addRequired('fkModalitaTraumatismo');
    // this.addRequiredGroup('incidenteTrasporti', 'incidenteTrasportoMezzo');
    // this.addRequiredGroup('incidenteTrasporti', 'fkIncidenteTrasportoRuolo');
    // this.addRequiredGroup('incidenteTrasporti', 'incidenteTrasportoTipo');
    // this.addRequiredGroup('dataEvento', 'orarioEventoHh');
    // this.addRequiredGroup('dataEvento', 'orarioEventoMm');
    // this.addRequiredGroup('dataEvento', 'data8selected');
    // this.addRequired('fkLuogoEvento');

    this.parteAForm.get('eventoOrigineTraumatismo')?.updateValueAndValidity();
    this.parteAForm.get('fkModalitaTraumatismo')?.updateValueAndValidity();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoMezzo')?.updateValueAndValidity();
    // this.parteAForm.get('incidenteTrasporti')?.get('fkIncidenteTrasportoRuolo')?.updateValueAndValidity();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoTipo')?.updateValueAndValidity();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoHh')?.updateValueAndValidity();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoMm')?.updateValueAndValidity();
    // this.parteAForm.get('dataEvento')?.get('data8selected')?.updateValueAndValidity();
    // this.parteAForm.get('fkLuogoEvento')?.updateValueAndValidity();
  }

  removeQuesiti() {
    this.parteAForm.get('eventoTraumatismo')?.setValue('F');
    this.parteAForm.get('eventoOrigineTraumatismo')?.clearValidators();
    this.parteAForm.get('fkModalitaTraumatismo')?.clearValidators();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoMezzo')?.clearValidators();
    // this.parteAForm.get('incidenteTrasporti')?.get('fkIncidenteTrasportoRuolo')?.clearValidators();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoTipo')?.clearValidators();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoHh')?.clearValidators();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoMm')?.clearValidators();
    // this.parteAForm.get('dataEvento')?.get('data8selected')?.clearValidators();
    // this.parteAForm.get('fkLuogoEvento')?.clearValidators();

    this.parteAForm.get('eventoOrigineTraumatismo')?.reset();
    this.parteAForm.get('fkModalitaTraumatismo')?.reset();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoMezzo')?.reset();
    // this.parteAForm.get('incidenteTrasporti')?.get('fkIncidenteTrasportoRuolo')?.reset();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoTipo')?.reset();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoHh')?.reset();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoMm')?.reset();
    // this.parteAForm.get('dataEvento')?.get('data8selected')?.reset();
    // this.parteAForm.get('fkLuogoEvento')?.reset();

    this.parteAForm.get('eventoOrigineTraumatismo')?.updateValueAndValidity();
    this.parteAForm.get('fkModalitaTraumatismo')?.updateValueAndValidity();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoMezzo')?.updateValueAndValidity();
    // this.parteAForm.get('incidenteTrasporti')?.get('fkIncidenteTrasportoRuolo')?.updateValueAndValidity();
    // this.parteAForm.get('incidenteTrasporti')?.get('incidenteTrasportoTipo')?.updateValueAndValidity();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoHh')?.updateValueAndValidity();
    // this.parteAForm.get('dataEvento')?.get('orarioEventoMm')?.updateValueAndValidity();
    // this.parteAForm.get('dataEvento')?.get('data8selected')?.updateValueAndValidity();
    // this.parteAForm.get('fkLuogoEvento')?.updateValueAndValidity();
  }

  //

  //aggiunge il required dei form dal 5 al 9 in base all'opzione selezionata nel checkbox dei traumatismi/avvelenamenti

  addRequired(form: string) {
    this.parteAForm.get(form)?.addValidators(Validators.required);
    this.parteAForm.get(form)?.updateValueAndValidity();
  }

  addRequiredGroup(parent: string, child: string) {
    this.parteAForm.get(parent)?.get(child)?.addValidators(Validators.required);
    this.parteAForm.get(parent)?.get(child)?.updateValueAndValidity();
  }

  //

  isHiddenQuesitiSubjectSubscription: Subscription | undefined;
  constructor(private formBuilder: FormBuilder, private sharedFormService: SharedFormService, private apiService: ApiService,
              private assignComuni: AssignComuniService, private switchModalita: SwitchModalitaService) {

    this.parteAForm = this.sharedFormService.form.get('parteA') as FormGroup;
    this.id = this.route.snapshot.params['id'];
    this.isHiddenQuesitiSubjectSubscription = this.isHiddenQuesitiSubject.subscribe(value => {
      if (!value) {
        this.addQuesiti();
      }
      else {
        this.removeQuesiti();
      }
    })
    if (this.id) {
      if (this.parteAForm.get('eventoTraumatismo')?.value == 'T') {
        this.isHiddenQuesiti = false;
        this.isHiddenQuesitiSubject.next(false);
      }
      else {
        this.isHiddenQuesiti = true;
        this.isHiddenQuesitiSubject.next(true);
      }
    }
    else{
      this.isHiddenQuesiti = true;
      this.isHiddenQuesitiSubject.next(true);
    }
  }


  async ngOnInit() {
   
    this.condizione1Subscription = this.parteAForm.get('causaMorteCondizioni')?.get('condizione1')?.statusChanges.subscribe(() => {
      if (this.parteAForm.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2')?.value != '' && this.parteAForm.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2Giorni')?.value != '') {
        this.activateCondizione2 = true;
      }
      else {
        this.activateCondizione2 = false;
      }
    });
    this.condizione2Subscription = this.parteAForm.get('causaMorteCondizioni')?.get('condizione2')?.statusChanges.subscribe(() => {
      if (this.parteAForm.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3')?.value != '' && this.parteAForm.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3Giorni')?.value != '') {
        this.activateCondizione3 = true;
      }
      else {
        this.activateCondizione3 = false;
      }
    });
    this.condizione3Subscription = this.parteAForm.get('altriStatiMorbosi')?.get('stato1')?.statusChanges.subscribe(() => {
      if (this.parteAForm.get('altriStatiMorbosi')?.get('stato1')?.get('statostatiMorbosi1')?.value != '' && this.parteAForm.get('altriStatiMorbosi')?.get('stato1')?.get('statostatiMorbosi1Giorni')?.value != '') {
        this.activateStato2 = true;
      }
      else {
        this.activateStato2 = false;
      }
    });
    this.condizione4Subscription = this.parteAForm.get('altriStatiMorbosi')?.get('stato2')?.statusChanges.subscribe(() => {
      if (this.parteAForm.get('altriStatiMorbosi')?.get('stato2')?.get('stato')?.value != '' && this.parteAForm.get('altriStatiMorbosi')?.get('stato2')?.get('giorni')?.value != '') {
        this.activateStato3 = true;
      }
      else {
        this.activateStato3 = false;
      }
    });

    /*this.dizionariSubscription = this.apiService.getDizionari().subscribe(dizionari => {
      this.dizionari = dizionari;
      this.dizionarioLuogoDecesso = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'LUOGO_DECESSO');
      this.dizionarioStatoGravidanza = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'STATO_GRAVIDANZA');
      this.dizionarioModalitaTraumatismo = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'MODALITA_TRAUMATISMO');
      this.dizionarioTrasportoRuolo = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'RUOLO_VITTIMA');
      this.dizionarioLuogoEvento = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'LUOGO_TRAUMATISMO');
      this.dizionarioTipoMedico = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'TIPO_MEDICO');
    });*/
    this.dizionari = await firstValueFrom(this.apiService.getDizionari());
    if(this.dizionari instanceof Array) {
      this.dizionarioLuogoDecesso = this.dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'LUOGO_DECESSO');
      this.dizionarioStatoGravidanza = this.dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'STATO_GRAVIDANZA');
      this.dizionarioModalitaTraumatismo = this.dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'MODALITA_TRAUMATISMO');
      this.dizionarioTrasportoRuolo = this.dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'RUOLO_VITTIMA');
      this.dizionarioLuogoEvento = this.dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'LUOGO_TRAUMATISMO');
      this.dizionarioTipoMedico = this.dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'TIPO_MEDICO');
    }
    //torno icd10
    this.icd10Subscription = await this.apiService.getIcd10().subscribe(icd10 => {
      this.icd10 = icd10;
      this.icd10.forEach((icd: Icd10) => {
        icd.descrizione = icd.descrizione?.trim();
      })
      this.icd10Descrizione = icd10.map((icd: Icd10) => icd.descrizione);
    })
    //torno i comuni
    this.comuniSubscription = await this.apiService.getComuni().subscribe(comuni => {
      this.comuni = comuni;
      this.assignComuni.comuni = comuni;
      this.assignComuni.comuni.forEach((comune: Comune) => {
        comune.descrComune = comune.descrComune?.trim();
      })
      this.descrComune = comuni.map((comune: Comune) => comune.descrComune);
      if (this.parteAForm.get('territorioDecesso')?.get('fkComuneDecesso')?.value != undefined) {
        const selectedComune = this.comuni.find((comune: Comune) => comune.codComune?.trim() === this.parteAForm.get('territorioDecesso')?.get('fkComuneDecesso')?.value.trim() && comune.codAsl?.toString().trim() == this.parteAForm.get('territorioDecesso')?.get('codiceAslDecesso')?.value.trim());
        this.parteAForm.get('territorioDecesso')?.get('fkComuneDecessoDescr')?.setValue(selectedComune?.descrComune);
        this.parteAForm.get('territorioDecesso')?.get('descrAslDecesso')?.setValue(selectedComune?.descrAsl);
      }
    })

    
    this.condizione5Subscription = this.parteAForm.get('territorioDecesso')?.get('fkComuneDecessoDescr')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('territorioDecesso')?.get('fkComuneDecessoDescr')?.value != undefined) {
        const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.parteAForm.get('territorioDecesso')?.get('fkComuneDecessoDescr')?.value.trim());
        this.parteAForm.get('territorioDecesso')?.get('fkComuneDecesso')?.setValue(selectedComune?.codComune);
        console.log(selectedComune)
        this.parteAForm.get('territorioDecesso')?.get('provincia')?.setValue(selectedComune?.sigla);
      }
    })
  }

  onChangeComuneDecesso() {
    if (this.parteAForm.get('territorioDecesso')?.get('fkComuneDecesso')?.value != null) {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.parteAForm.get('territorioDecesso')?.get('fkComuneDecessoDescr')?.value.trim());
      this.parteAForm.get('territorioDecesso')?.get('descrAslDecesso')?.setValue(selectedComune?.descrAsl);
      this.parteAForm.get('territorioDecesso')?.get('codiceAslDecesso')?.setValue(selectedComune?.codAsl);
    }
  }

  //se la scheda è già esistente recupero il codice del comune dal db e lo converto in descrizione assegnandolo a fkComuneDecessoDescr
  ngAfterViewInit() {
    if (!this.schedaMorte.modalita && !this.schedaMorte.giaInModifica) {
      console.log(this.schedaMorte.modalita)
      console.log(this.schedaMorte.giaInModifica)
      this.parteAForm.disable();
      this.disableSelect = true;
    }
    else {
      this.parteAForm.enable();
      this.disableSelect = false;
    }
    this.schedaMorte.modificaSubject.pipe(first()).subscribe((modifica: boolean) => {
      if (modifica) {
        this.parteAForm.enable();
        this.disableSelect = false;
      }
    });
    this.condizione6Subscription = this.parteAForm.get('causaMortePatologia')?.get('causaDiMorte1')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('causaMortePatologia')?.get('causaDiMorte1')?.value != undefined) {
        const selectedCodiceIcd10 = this.icd10.find((icd: Icd10) => icd.descrizione.trim() === this.parteAForm.get('causaMortePatologia')?.get('causaDiMorte1')?.value.trim());
        this.parteAForm.get('causaMortePatologia')?.get('causaDiMorte1Cod')?.setValue(selectedCodiceIcd10?.codice);
      }
    })
    this.condizione7Subscription = this.parteAForm.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2')?.value != undefined) {
        const selectedCodiceIcd10 = this.icd10.find((icd: Icd10) => icd.descrizione.trim() === this.parteAForm.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2')?.value.trim());
        this.parteAForm.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2Cod')?.setValue(selectedCodiceIcd10?.codice);
      }
    })
    this.condizione8Subscription = this.parteAForm.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3')?.value != undefined) {
        const selectedCodiceIcd10 = this.icd10.find((icd: Icd10) => icd.descrizione.trim() === this.parteAForm.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3')?.value.trim());
        this.parteAForm.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3Cod')?.setValue(selectedCodiceIcd10?.codice);
      }
    })
    this.condizione9Subscription = this.parteAForm.get('causaMorteCondizioni')?.get('condizione3')?.get('causaDiMorte4')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('causaMorteCondizioni')?.get('condizione3')?.get('causaDiMorte4')?.value != undefined) {
        const selectedCodiceIcd10 = this.icd10.find((icd: Icd10) => icd.descrizione.trim() === this.parteAForm.get('causaMorteCondizioni')?.get('condizione3')?.get('causaDiMorte4')?.value.trim());
        this.parteAForm.get('causaMorteCondizioni')?.get('condizione3')?.get('causaDiMorte4Cod')?.setValue(selectedCodiceIcd10?.codice);
      }
    })
    this.condizione10Subscription = this.parteAForm.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1')?.value != undefined) {
        const selectedCodiceIcd10 = this.icd10.find((icd: Icd10) => icd.descrizione.trim() === this.parteAForm.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1')?.value.trim());
        this.parteAForm.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1Cod')?.setValue(selectedCodiceIcd10?.codice);
      }
    })
    this.condizione11Subscription = this.parteAForm.get('altriStatiMorbosi')?.get('stato2')?.get('statiMorbosi2')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('altriStatiMorbosi')?.get('stato2')?.get('statiMorbosi2')?.value != undefined) {
        const selectedCodiceIcd10 = this.icd10.find((icd: Icd10) => icd.descrizione.trim() === this.parteAForm.get('altriStatiMorbosi')?.get('stato2')?.get('statiMorbosi2')?.value.trim());
        this.parteAForm.get('altriStatiMorbosi')?.get('stato2')?.get('statiMorbosi2Cod')?.setValue(selectedCodiceIcd10?.codice);
      }
    })
    this.condizione12Subscription = this.parteAForm.get('altriStatiMorbosi')?.get('stato3')?.get('statiMorbosi3')?.valueChanges.subscribe(() => {
      if (this.parteAForm.get('altriStatiMorbosi')?.get('stato3')?.get('statiMorbosi3')?.value != undefined) {
        const selectedCodiceIcd10 = this.icd10.find((icd: Icd10) => icd.descrizione.trim() === this.parteAForm.get('altriStatiMorbosi')?.get('stato3')?.get('statiMorbosi3')?.value.trim());
        this.parteAForm.get('altriStatiMorbosi')?.get('stato3')?.get('statiMorbosi3Cod')?.setValue(selectedCodiceIcd10?.codice);
      }
    })
  }


  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2 ? [] : this.descrComune.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  searchIcd10: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2 ? [] : this.icd10Descrizione.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    )

  searchAsl: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2 ? [] : this.aslDescr.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    )

  onDateSelect(data: NgbDateStruct, group: string, form: string) {
    if (data) {
      const dataSelezionata = new Date(data.year, data.month - 1, data.day);
      this.parteAForm.get(group)?.get(form)?.setValue(dataSelezionata);
    }
  }



  setSelectedOption(variable: any, value: any, form: string) {
    if (variable === value) {
      this.parteAForm.get(form)?.addValidators(Validators.required);
    }
    else {
      this.parteAForm.get(form)?.clearValidators();
      this.parteAForm.get(form)?.reset();
    }
    this.parteAForm.get(form)?.updateValueAndValidity();
  }

  setSelectedOptionGroup(variable: any, group: any, value: any, form: string) {
    if (variable === value) {
      this.parteAForm.get(form)?.get(group)?.addValidators(Validators.required);
    }
    else {
      this.parteAForm.get(form)?.get(group)?.clearValidators();
      this.parteAForm.get(form)?.get(group)?.reset();
    }
    this.parteAForm.get(form)?.get(group)?.updateValueAndValidity();
  }

  ngOnDestroy() {
    if(this.condizione1Subscription){
      this.condizione1Subscription.unsubscribe();
    }
    if(this.condizione2Subscription){
      this.condizione2Subscription.unsubscribe();
    }
    if(this.condizione3Subscription){
      this.condizione3Subscription.unsubscribe();
    }
    if(this.condizione4Subscription){
      this.condizione4Subscription.unsubscribe();
    }
    if(this.condizione5Subscription){
      this.condizione5Subscription.unsubscribe();
    }
    if(this.condizione6Subscription){
      this.condizione6Subscription.unsubscribe();
    }
    if(this.condizione7Subscription){
      this.condizione7Subscription.unsubscribe();
    }
    if(this.condizione8Subscription){
      this.condizione8Subscription.unsubscribe();
    }
    if(this.condizione9Subscription){
      this.condizione9Subscription.unsubscribe();
    }
    if(this.condizione10Subscription){
      this.condizione10Subscription.unsubscribe();
    }
    if(this.condizione11Subscription){
      this.condizione11Subscription.unsubscribe();
    }
    if(this.condizione12Subscription){
      this.condizione12Subscription.unsubscribe();
    }
    if(this.dizionariSubscription){
      this.dizionariSubscription.unsubscribe();
    }
    if(this.icd10Subscription){
      this.icd10Subscription.unsubscribe();
    }
    if(this.comuniSubscription){
      this.comuniSubscription.unsubscribe();
    }
    if(this.isHiddenQuesitiSubjectSubscription){
      this.isHiddenQuesitiSubjectSubscription?.unsubscribe()}
  }
}
